module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07472_banner_800x600.dd35e0fc.png";